import { Colors, Flex, Typography } from '@banhala/ui-kit';
import { Path, Svg } from 'react-native-svg';
import { MARKET_AVATAR_SIZE, MARKET_ITEM_WIDTH } from './MarketItem';

interface MarketMoreItemProps {
  onPress: () => void;
}

export const MarketMoreItem = ({ onPress }: MarketMoreItemProps) => {
  return (
    <Flex width={MARKET_ITEM_WIDTH} alignItems={'center'} onPress={onPress}>
      <Flex.Center
        width={MARKET_AVATAR_SIZE}
        height={MARKET_AVATAR_SIZE}
        borderRadius={MARKET_AVATAR_SIZE / 2}
        borderWidth={1}
        borderColor={'border_transparent'}
        backgroundColor={'bg_secondary'}
      >
        <ArrowMoreIcon />
      </Flex.Center>
      <Flex padding={{ top: 6 }}>
        <Typography
          type={'body3'}
          color={'content_secondary'}
          numberOfLines={1}
          textAlign={'center'}
        >
          더보기
        </Typography>
      </Flex>
    </Flex>
  );
};

// 네이티브의 iconArrowMore / icon_arrow_more와 동일한 긴 화살표 아이콘.
const ArrowMoreIcon = () => (
  <Svg width={24} height={24} viewBox={'0 0 22 22'}>
    <Path
      fillRule={'evenodd'}
      clipRule={'evenodd'}
      d={
        'M4.717,10.083L14.956,10.083l-4.474,-4.473c-0.357,-0.357 -0.357,-0.944 -0,-1.302 0.358,-0.357 0.935,-0.357 1.293,-0l6.04,6.041c0.358,0.358 0.358,0.935 -0,1.293l-6.03,6.05c-0.358,0.357 -0.936,0.357 -1.293,-0 -0.358,-0.358 -0.358,-0.935 -0,-1.293l4.464,-4.482l-10.24,-0c-0.504,-0 -0.916,-0.413 -0.916,-0.917s0.412,-0.917 0.917,-0.917z'
      }
      fill={Colors.content_primary}
    />
  </Svg>
);
